module.exports = function() {
  return new Worker(__webpack_public_path__ + "c6fc2038b5540501c256.worker.js");
};